import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import MomentUtils from '@date-io/moment';

import ScheduleIcon from '@material-ui/icons/Schedule';

import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker
} from '@material-ui/pickers';

import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';

import { useStyles } from './styles';

const TimePicker = ({
  input,
  meta: { touched, error, submitFailed },
  label,
  isHiddenErrorMsg,
  className
}) => {
  const classes = useStyles();
  const [t] = useTranslation();

  const onChangeHandler = date => {
    input.onChange(date);
  };

  return (
    <div className={classNames(classes.root, className)}>
      <InputLabel
        className={classes.label}
        htmlFor={`${label}-input`}
        classes={{
          disabled: classes.disabledLabel
        }}
      >
        {t(label)}
      </InputLabel>

      <div
        className={classNames('custom-time-picker', classes.customTimePicker, {
          [classes.error]: (submitFailed || touched) && error
        })}
      >
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <KeyboardTimePicker
            clearable={false}
            ampm={false}
            label={label}
            value={input.value}
            onChange={onChangeHandler}
            invalidDateMessage={false}
          />
        </MuiPickersUtilsProvider>
        <ScheduleIcon className={classes.scheduleIcon} />
      </div>

      {!isHiddenErrorMsg && (touched || submitFailed) && error && (
        <FormHelperText error>{error}</FormHelperText>
      )}
    </div>
  );
};

export default TimePicker;
